import { Link } from "wouter";
import { LegalLayout } from "./_legal-layout";

export default function CookiesPage() {
  return (
    <LegalLayout
      kicker="// legal · 03"
      title={
        <>
          Cookie <span className="font-italic-serif text-secondary">Policy.</span>
        </>
      }
      effectiveDate="January 1, 2026"
      intro={
        <p>
          This Cookie Policy explains how MainLoop uses cookies and similar technologies
          when you visit or use our website and apps. It works alongside our{" "}
          <Link href="/privacy" className="text-primary hover:underline">Privacy Policy</Link>.
        </p>
      }
    >
      <h2>1. What is a cookie?</h2>
      <p>
        A cookie is a small text file a website stores in your browser. Cookies let a
        site remember things about your visit — like that you&rsquo;re signed in or
        which preferences you&rsquo;ve set. Similar technologies include local storage
        and session storage, which work in much the same way.
      </p>

      <h2>2. Cookies we use</h2>

      <h3>Strictly necessary</h3>
      <p>
        These cookies are required to run the Service — for example, to keep you signed
        in and to protect against forgery. You cannot turn them off without breaking
        core functionality.
      </p>
      <ul>
        <li>
          <code>__session</code>, <code>__client</code> and related cookies set by
          our authentication provider (Clerk) to maintain your session.
        </li>
        <li>
          <code>connect.sid</code> or similar, used for server-side session and CSRF
          protection.
        </li>
      </ul>

      <h3>Functional</h3>
      <p>
        These remember your preferences (such as theme or last-viewed lesson) so the
        Service feels consistent across visits.
      </p>

      <h3>Analytics (planned)</h3>
      <p>
        When we add product analytics, we will use first-party cookies or local storage
        to count visits, measure feature usage, and diagnose problems. We will use
        privacy-respecting analytics that do not build cross-site advertising profiles.
      </p>

      <h3>Third-party</h3>
      <p>
        Third parties we integrate with (Zoom for live classes, Stripe for payments) may
        set their own cookies when you interact with their features. Their cookies are
        subject to their own privacy and cookie policies.
      </p>

      <h2>3. We do not use advertising cookies</h2>
      <p>
        MainLoop does not use cookies to deliver targeted advertising and does not allow
        third-party advertising trackers on the Service.
      </p>

      <h2>4. Managing cookies</h2>
      <p>
        Most browsers let you view, delete, and block cookies through their settings.
        Blocking strictly necessary cookies will prevent you from signing in or
        completing payments.
      </p>
      <ul>
        <li>
          <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">
            Manage cookies in Chrome
          </a>
        </li>
        <li>
          <a href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox" target="_blank" rel="noreferrer">
            Manage cookies in Firefox
          </a>
        </li>
        <li>
          <a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noreferrer">
            Manage cookies in Safari
          </a>
        </li>
        <li>
          <a href="https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge" target="_blank" rel="noreferrer">
            Manage cookies in Edge
          </a>
        </li>
      </ul>

      <h2>5. Changes to this policy</h2>
      <p>
        We will update this page when we add or remove cookies. The effective date at the
        top tells you when it was last revised.
      </p>

      <h2>6. Contact</h2>
      <p>
        Questions about how we use cookies? Email{" "}
        <a href="mailto:info@mainloopacademy.com">info@mainloopacademy.com</a>.
      </p>
    </LegalLayout>
  );
}
